import DefaultService from "./default";

export default { 
    ...DefaultService,
 };